import React from 'react';
import { useListLiveProjectsQuery } from '../../../../generated/core-api/graphql-react-query';
import useGlobalStoreContext from '../../GlobalContext/Contexts/GlobalStoreContext/useGlobalStoreContext';
import { ProjectInfoContext } from './useProjectInfoContext';

export default function ProjectInfoContextProvider({ children }: { children: React.ReactNode }) {
  const projects = useListLiveProjectsQuery({});
  const { projectId: [projectId] } = useGlobalStoreContext();

  const value = React.useMemo(() => ({
    project: projects.data?.listProjects.find((p) => p.id === projectId) ?? null,
    projects: projects.data?.listProjects ?? [],
  }), [projectId, projects.data]);

  return (
    <ProjectInfoContext.Provider value={value}>
      {children}
    </ProjectInfoContext.Provider>
  );
}
